import { theme } from "@mindmemobile/mm-shared-global";
import styled from "styled-components";

const { common } = theme.palette;
interface IStyleProps {
  noScroll?: boolean;
  padding?: string;
  footer?: boolean;
}

export const ItemContainer = styled.div<IStyleProps>`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.padding || "30px 40px 30px 50px"};
  background-color: ${common.white};
  /* height: ${(props) => (props.footer ? "calc(100vh - 20px)" : "100%")}; */
  height: 100%;
  &.float-aside{
    /* width: calc(100% - 490px); */
    width: 60%;
    overflow-x: auto;
    min-width: 55%;
  }
`;
export const ItemContentBody = styled.div<IStyleProps>`
  flex: 1 1 0;
  background-color: ${common.white};
  overflow-y: ${(props) => (props.noScroll ? "hidden" : "auto")};
  overflow-x: hidden;
  /* padding-right: 30px; */
  > div {
    height: 100%;
  }
  .main-panel {
    height: 100%;
    > div:not(.layout-footer) {
      width: 100%;
    }
    /* .donation-ad-block {
      overflow-y: unset;
      max-height: unset;
    } */
  }
  &::-webkit-scrollbar {
    width: 0.5em;
    height: 0.4em;
    background: rgba(21, 40, 55, 0.1);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    outline: 1px solid #ddd;
    background-color: rgba(21, 40, 55, 0.3);
    border-radius: 10px;
  }
  .content-label-primary {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 25px;
    display: inline-block;
  }
`;
